import { useEffect } from 'react';

import Modal from './modal';

import './styles.css';

import Logo from './images/logo.jpg';
import GamesTemplate from '../gamesDemo';

export const Step3 = ({onNext}) => {
  useEffect(() => {
    const goNextTimeout = setTimeout(() => {
      onNext();
    }, 15500);
    return () => clearTimeout(goNextTimeout);
  }, [onNext]);

  return (
    <Modal className="step-3">
      <img src={Logo} alt="Logo" className="onboarding-logo" />
      <h4>Market Games</h4>
      <div className="fade-text-wrapper">
        <p className="fade-sequence-1">
          To help you master the basics and excel in your course, your instructor assigned one or more of our <b>Accounting Basics exercises</b>.
        </p>
        <p className="fade-sequence-2">
          These exercises are designed to help you catch and fix learning gaps quickly.
        </p>
        <p className="fade-sequence-3">
          In each assignment, <b>you’ll have up to 3 tries and we’ll always count your best score</b>.
        </p>
      </div>
      <GamesTemplate />
    </Modal>
  )
};